import messages from './cmsOrder.json' with { type: 'json' };

export const cmsOrderFi: Readonly<typeof messages> = messages;
